import { IntegratorResponse } from "../api/GetIntegratorListResponse";

export interface IntegratorItem {
    id: string;
    name: string;
    updatedDate: string;
    isModified: boolean;
}

export const mapToIntegratorItem = (item: IntegratorResponse): IntegratorItem => {
    return {
        id: item.id,
        name: item.name,
        updatedDate: item.updatedDate,
        isModified: false
    };
};
